import { Button, Col, Form, Input, message, Modal, Row } from "antd";
import React, { useEffect, useState } from "react";
import http from "../../utils/http";

function ContactComponent({ IsOpen, OkFn, CancenFn, setIsOpen }) {
  const [form] = Form.useForm();
   // 新增：管理按钮禁用状态
   const [isSendButtonDisabled, setIsSendButtonDisabled] = useState(false);
   // 新增：管理倒计时
   const [countdown, setCountdown] = useState(0);
 
   const onfinish = (values) => {
     console.log(values);
     // 设置按钮禁用
     setIsSendButtonDisabled(true);
     // 设置倒计时为 60 秒
     setCountdown(60);
     http.post("/api/leave_word/",values)
     .then(res=>{
         message.success("Submit successfully");
         setIsOpen(false);
         form.resetFields();
     })
     .catch(err=>{})
   };
   // 处理倒计时逻辑
   useEffect(() => {
     let timer;
     if (countdown > 0) {
       // 每秒减少倒计时的值
       timer = setInterval(() => {
         setCountdown(prevCountdown => prevCountdown - 1);
       }, 1000);
     } else if (countdown === 0 && isSendButtonDisabled) {
       // 倒计时结束，重置按钮状态
       setIsSendButtonDisabled(false);
     }
     // 组件卸载或倒计时变化时清除定时器
     return () => clearInterval(timer);
   }, [countdown, isSendButtonDisabled]);
 
  const onReset = () => {
    form.resetFields();
   };
  return (
    <div>
      <Modal
        width={700}
        open={IsOpen}
        footer={false}
        onOk={OkFn}
        onCancel={CancenFn}
      >
        <div
          style={{
            width: "90%",
            height: "100%",
            margin: "20px auto",
          }}
        >
          <Form
            form={form}
            onFinish={onfinish}
            onReset={onReset}
            layout="vertical"
          >
            <Row>
              <Col span={8}>
                <Form.Item
                  name="name"
                  label={<span style={{ fontWeight: "bold" }}>Name</span>}
                  rules={[
                    {
                      required: true,
                      message: "Please input your name!",
                    },
                  ]}
                >
                  <Input placeholder="Please enter your name" />
                </Form.Item>
              </Col>
              <Col span={8}></Col>
              <Col span={8}>
                <Form.Item
                  name="email"
                  label={<span style={{ fontWeight: "bold" }}>Email</span>}
                  rules={[
                    {
                      required: true,
                      message: "Please input your email!",
                    },
                  ]}
                >
                  <Input placeholder="Please enter your email" />
                </Form.Item>
              </Col>
            </Row>
            <Form.Item
              label={<span style={{ fontWeight: "bold" }}>Cell Phone</span>}
              name="phone"
              rules={[
                {
                  required: true,
                  message: "Please input your cellphone!",
                },
              ]}
            >
              <Input placeholder="Please enter your cellphone" />
            </Form.Item>
            <Form.Item
              label={<span style={{ fontWeight: "bold" }}>Message</span>}
              name="notes"
              rules={[
                {
                  required: true,
                  message: "Please input your message!",
                },
              ]}
            >
              <Input.TextArea
                placeholder="Please enter your message"
                maxLength={300}
                autoSize={{ minRows: 2, maxRows: 6 }}
                showCount={true}
              />
            </Form.Item>
            <Form.Item
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
               <Button
                style={{
                  margin: "0 10px",
                  background:isSendButtonDisabled?"#ccc": "#46766a",
                  border:isSendButtonDisabled?"1px solid #ccc": "1px solid #46766a",
                  color: "white",
                }}
                htmlType="submit"
                type="primary"
                // 添加禁用属性和显示倒计时
                disabled={isSendButtonDisabled}
              >
                {isSendButtonDisabled ? `Send (${countdown}s)` : 'Send'}
              </Button>
              <Button
                style={{
                  margin: "0 10px",
                  border: "1px solid #46766a",
                  color: "#46766a",
                }}
              >
                Reset
              </Button>
            </Form.Item>
          </Form>
        </div>
      </Modal>
    </div>
  );
}

export default ContactComponent;
